import SystemLogListView from '../../components/SystemLogListView';

SystemLogListScreen.propTypes = {};

function SystemLogListScreen(props) {
  return (
    <div className="container-fluid px-4 my-4">
      <SystemLogListView />
    </div>
  );
}

export default SystemLogListScreen;
